import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import SubmitButton, { useCustomFormik } from 'src/components/formik-helper';
import StringTextField from 'src/components/widgets/string-textfield';
import DateAndTimePicker from 'src/components/widgets/date-time-picker';
import SearchSelectField from 'src/components/widgets/search-select-field';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';

import {
  initialValues,
  validationSchema,
  handleSubmitted,
  generateRandom,
} from './formik';

export const DetailForm = (props) => {
  const {
    filters = {},
    onFiltersChange,
    item,
    brandOptions = [],
    carOptions = [],
    gearOptions = [],
    apiEndpoint,
    apiUpdate,
    apiDelete,
    ...other
  } = props;

  // Update car options
  const [carNameOptions, setCarNameOptions] = useState([]);
  const [carNameDefault, setCarNameDefault] = useState(null);
  const [gearDefault, setGearDefault] = useState(null);
  const [defaultVal, setDefaultVal] = useState({});

  useEffect(() => {
    let frame;
    let engine;

    if (item) {
      frame = item.frameSerial;
      engine = item.engineSerial;

      // Set default values if item exists
      setDefaultVal({
        carId: item.id,
        plate: item.plate,
        frame,
        engine,
      });
    } else {
      // Generate random values if item does not exist
      frame = generateRandom();
      engine = generateRandom();

      setDefaultVal({
        frame,
        engine,
      });
    }
  }, [item]);

  const formik = useCustomFormik({
    initialValues: initialValues(item),
    validationSchema: validationSchema(defaultVal),

    onSubmit: async (values, helpers) => {
      //await handleSubmitted(values, item, apiUpdate, apiDelete);
    },
  });

  const handleBrandChanged = (selectedOption) => {
    const option = selectedOption?.value;
    if (option) {
      const item = carOptions[option];
      setCarNameOptions(item);
      setCarNameDefault(item[0]);
      setGearDefault(gearOptions[0]);
    } else {
      setCarNameOptions([]);
      setCarNameDefault(null);
      setGearDefault(null);
    }
  };

  return (
    <form onSubmit={formik.handleSubmit} {...other}>
      <Card>
        <CardContent sx={{ px: 1, py: 2 }}>
          <Grid container spacing={3}>
            <Grid xs={12} md={4}>
              <ReadOnlyTextField
                label="Biển số xe"
                value={item.plate} />
            </Grid>

            <Grid xs={12} md={4}>
              <SearchSelectField
                label="Thương hiệu"
                name="brand"
                formik={formik}
                options={brandOptions}
                onSelected={handleBrandChanged}
                hintValue={item.brand}
              />
            </Grid>

            <Grid xs={12} md={4}>
              <SearchSelectField
                label="Hiệu xe"
                name="carName"
                formik={formik}
                options={carNameOptions}
                defaultValue={carNameDefault}
                hintValue={item.name}
              />
            </Grid>

            <Grid xs={12} md={4}>
              <SearchSelectField
                label="Hộp số"
                name="gear"
                formik={formik}
                options={gearOptions}
                defaultValue={gearDefault}
                hintValue={'Số sàn'}
              />
            </Grid>

            <Grid xs={12} md={4}>
              <StringTextField
                label="Số khung"
                name="frameSerial"
                formik={formik}
                onChangeValue={(val) => {
                  return val.toUpperCase();
                }}
                hintValue={item.frameSerial}
              />
            </Grid>

            <Grid xs={12} md={4}>
              <StringTextField
                label="Số máy"
                name="engineSerial"
                formik={formik}
                onChangeValue={(val) => {
                  return val.toUpperCase();
                }}
                hintValue={item.engineSerial}
              />
            </Grid>

            <Grid xs={12} md={4}>
              <StringTextField
                label="Số xe"
                name="carNumber"
                formik={formik}
                inputProps={{ maxLength: 4 }}
                hintValue={item?.number}
              />
            </Grid>

            <Grid xs={12} md={4}>
              <DateAndTimePicker
                label="Ngày mua"
                name="purchaseDate"
                format="dd/MM/yyyy"
                formik={formik}
                hintValue={item?.purchaseDate}
              />
            </Grid>

            <Grid xs={12} md={4}>
              <ReadOnlyTextField
                label="Loại xe"
                value={item.groupName} />
            </Grid>
          </Grid>
        </CardContent>

        {/* <SubmitButton formik={formik} /> */}
      </Card>
    </form>
  );
};

DetailForm.propTypes = {
  item: PropTypes.object.isRequired,
};